(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "color", "prop-types", "react", "./formField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("color"), require("prop-types"), require("react"), require("./formField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.color, global.propTypes, global.react, global.formField);
    global.ColorpickerField = mod.exports;
  }
})(this, function (_exports, _color, _propTypes, _react, _formField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.ColorpickerFieldRaw = void 0;
  _color = _interopRequireDefault(_color);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _formField = _interopRequireDefault(_formField);

  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

  function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  /**
   * check if a string is a valid color value
   *
   * @param {string} value color value string
   * @returns {boolean} whether the string is a valid color or not
   */
  function isValidColor(value) {
    try {
      // `color` throws an error when the value is not a valid color
      (0, _color["default"])(value);
      return true;
    } catch (e) {
      return false;
    }
  }

  var Coordinator =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Coordinator, _PureComponent);

    function Coordinator() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Coordinator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Coordinator)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "handleCoordChange", function (_ref) {
        var clientX = _ref.clientX,
            clientY = _ref.clientY;
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            width = _this$props.width,
            height = _this$props.height;

        var _this$node$getBoundin = _this.node.getBoundingClientRect(),
            top = _this$node$getBoundin.top,
            left = _this$node$getBoundin.left; // cap [0, 1]


        var rx = Math.max(0, Math.min((clientX - left) / width, 1));
        var ry = Math.max(0, Math.min((clientY - top) / height, 1)); // `x` and `y` values relative to the node's `width` and `height` {[0,1] [0,1]}

        onChange([rx, ry]);
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
        _this.handleCoordChange(e);

        window.addEventListener('mousemove', _this.handleCoordChange);
        window.addEventListener('mouseup', _this.handleMouseUp);
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function () {
        _this.unbindEventListeners();
      });

      return _this;
    }

    _createClass(Coordinator, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unbindEventListeners();
      }
    }, {
      key: "unbindEventListeners",
      value: function unbindEventListeners() {
        window.removeEventListener('mousemove', this.handleCoordChange);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            coords = _this$props2.coords,
            children = _this$props2.children,
            width = _this$props2.width,
            height = _this$props2.height,
            style = _this$props2.style,
            className = _this$props2.className;

        var _coords = _slicedToArray(coords, 2),
            rx = _coords[0],
            ry = _coords[1];

        var x = rx * width;
        var y = ry * height;
        return _react["default"].createElement("div", {
          className: className,
          style: _objectSpread({}, style || {}, {
            width: width,
            height: height
          }),
          ref: function ref(node) {
            _this2.node = node;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleCoordChange,
          onTouchStart: this.handleCoordChange
        }, children({
          x: x,
          y: y,
          rx: rx,
          ry: ry,
          width: width,
          height: height
        }));
      }
    }]);

    return Coordinator;
  }(_react.PureComponent);

  _defineProperty(Coordinator, "propTypes", {
    coords: _propTypes["default"].array.isRequired,
    width: _propTypes["default"].number.isRequired,
    height: _propTypes["default"].number.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    children: _propTypes["default"].func.isRequired,
    style: _propTypes["default"].object,
    className: _propTypes["default"].string
  });

  var ColorpickerFieldRaw =
  /*#__PURE__*/
  function (_Component) {
    _inherits(ColorpickerFieldRaw, _Component);

    function ColorpickerFieldRaw() {
      var _getPrototypeOf3;

      var _this3;

      _classCallCheck(this, ColorpickerFieldRaw);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(ColorpickerFieldRaw)).call.apply(_getPrototypeOf3, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this3), "state", {
        intermediateHexInput: null
      });

      _defineProperty(_assertThisInitialized(_this3), "changeColor", function (color) {
        if (isValidColor(color.string())) {
          _this3.setState({
            intermediateHexInput: color.hex()
          });

          var preciseColor = color.hue(Math.round(color.hue())).hsl().string();

          _this3.props.onChange(preciseColor);
        }
      });

      _defineProperty(_assertThisInitialized(_this3), "handleSvChange", function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            x = _ref3[0],
            y = _ref3[1];

        _this3.changeColor(_this3.color.saturationv(x * 100).value(100 - y * 100));
      });

      _defineProperty(_assertThisInitialized(_this3), "handleHueChange", function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _x = _ref5[0],
            y = _ref5[1];

        _this3.changeColor(_this3.color.hue(y * 360));
      });

      return _this3;
    }

    _createClass(ColorpickerFieldRaw, [{
      key: "render",
      value: function render() {
        var _this4 = this;

        var _this$props3 = this.props,
            className = _this$props3.className,
            _this$props3$dimensio = _this$props3.dimensions,
            width = _this$props3$dimensio.width,
            height = _this$props3$dimensio.height,
            hueWidth = _this$props3$dimensio.hueWidth,
            spacing = _this$props3$dimensio.spacing;
        var intermediateHexInput = this.state.intermediateHexInput;

        var _this$color$object = this.color.object(),
            h = _this$color$object.h,
            s = _this$color$object.s,
            v = _this$color$object.v;

        var styles = typeof className === 'string' ? {
          base: className,
          baseSaturationValue: "".concat(className, "-saturation-value-canvas"),
          baseHue: "".concat(className, "-hue"),
          baseHexInput: "".concat(className, "-hex-input"),
          saturation: "".concat(className, "-saturation"),
          value: "".concat(className, "-value"),
          marker: 'marker'
        } : this.props.className;
        var hueColor = this.color.saturationv(100).value(100).hex();

        var gradient = function gradient(direction, color) {
          return "linear-gradient(".concat(direction, ", transparent 0%, ").concat(color, " 100%)");
        };

        var hexColorString = this.hexInputValueChange ? intermediateHexInput : this.color.hex();
        return _react["default"].createElement("div", {
          className: styles.base
        }, _react["default"].createElement(Coordinator, {
          onChange: this.handleSvChange,
          className: styles.baseSaturationValue,
          width: width - (hueWidth + spacing),
          height: height,
          coords: [s / 100, v / 100]
        }, function (_ref6) {
          var x = _ref6.x,
              y = _ref6.y,
              height = _ref6.height;
          return [_react["default"].createElement("div", {
            key: "s",
            className: styles.saturation,
            style: {
              background: gradient('to right', hueColor)
            }
          }), _react["default"].createElement("div", {
            key: "v",
            className: styles.value,
            style: {
              background: gradient('to bottom', '#000')
            }
          }), _react["default"].createElement("div", {
            key: "marker",
            className: styles.marker,
            style: {
              left: Math.round(x),
              top: Math.round(height - y)
            }
          })];
        }), _react["default"].createElement(Coordinator, {
          onChange: this.handleHueChange,
          className: styles.baseHue,
          coords: [0, h / 360],
          width: hueWidth,
          height: height,
          style: {
            background: "linear-gradient(to bottom,\n              #ff0000 0%,\n              #ffff00 20%,\n              #00ff00 35%,\n              #00ffff 50%,\n              #0000ff 65%,\n              #ff00ff 80%,\n              #ff0000 100%)"
          }
        }, function (_ref7) {
          var y = _ref7.y;
          return _react["default"].createElement("div", {
            className: styles.marker,
            style: {
              top: Math.round(y)
            }
          });
        }), _react["default"].createElement("input", {
          className: styles.baseHexInput,
          type: "text",
          value: hexColorString,
          onChange: function onChange(e) {
            var value = e.target.value;
            _this4.hexInputValueChange = true;

            _this4.setState({
              intermediateHexInput: value
            }, function () {
              _this4.hexInputValueChange = false;
            });

            if (isValidColor(value)) {
              _this4.props.onChange((0, _color["default"])(value).hsl().round().string());
            }
          }
        }));
      }
    }, {
      key: "color",
      get: function get() {
        return (0, _color["default"])(this.props.value).hsv();
      }
    }]);

    return ColorpickerFieldRaw;
  }(_react.Component);

  _exports.ColorpickerFieldRaw = ColorpickerFieldRaw;

  _defineProperty(ColorpickerFieldRaw, "propTypes", {
    value: _propTypes["default"].string.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      base: _propTypes["default"].string.isRequired,
      baseSaturationValue: _propTypes["default"].string.isRequired,
      baseHue: _propTypes["default"].string.isRequired,
      saturation: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired,
      marker: _propTypes["default"].string.isRequired,
      baseHexInput: _propTypes["default"].string.isRequired
    })]).isRequired,
    dimensions: _propTypes["default"].shape({
      width: _propTypes["default"].number,
      height: _propTypes["default"].number,
      hueWidth: _propTypes["default"].number,
      spacing: _propTypes["default"].number
    })
  });

  _defineProperty(ColorpickerFieldRaw, "defaultProps", {
    dimensions: {
      width: 300,
      height: 300,
      hueWidth: 20,
      spacing: 5
    }
  });

  var _default = (0, _formField["default"])()(ColorpickerFieldRaw);

  _exports["default"] = _default;
});